import { useAppSelector } from "../../Redux/Hooks/hooks.redux";

export function useNetworkStatus(): Boolean  {
    return useAppSelector((state)=>(state.networkState.isApiDown))
}